import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { tA11y } from '@lwtears/lwt-common-frontend/lib/@common/util';
import { Button, Typography } from '@mui/material';
import HintIcon from '../../../../assets/icons/HintIcon';
import useActivityAudio from '../../../../hooks/use-activity-audio';
import useGame from '../../../../hooks/use-game';
import useHint from '../../../../hooks/use-hint';
import theme from '../../../../themes/defaultTheme';
import { hasOngoingAction } from '../../../../util/has-ongoing-action';
import useOverlay from '../../../../hooks/use-overlay';

const HintButton: React.FC = () => {
  const [{ showOverlay }] = useOverlay();
  const [{ showHint }, { setShowHint }] = useHint();
  const [
    {
      activityState: { currentPageCompleted, showAnimation },
    },
  ] = useGame();
  const [{ isPlaying }] = useActivityAudio();

  const classes = useStyles();

  return (
    <Button
      variant="contained"
      className={classes.hintBtn}
      disabled={
        hasOngoingAction(showHint, showAnimation, isPlaying) || showOverlay || currentPageCompleted
      }
      aria-label={tA11y('buttons.hint')}
      onClick={setShowHint}
      startIcon={<HintIcon fill={theme.palette.grey[900]} />}
    >
      <Typography variant="h3">{tA11y('buttons.hint')}</Typography>
    </Button>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  hintBtn: {
    height: '2.5rem',
    width: '5rem',
    border: 'none',
    boxShadow: '3px 3px 3px grey',
    background: theme.palette.primary.contrastText,
    borderRadius: '5px',
    color: theme.palette.grey[900],
    [theme.breakpoints.down('md')]: {
      margin: 0,
    },
    '&:hover': {
      background: '#d5d5d5',
      color: theme.palette.grey[900],
    },
  },
}));

export default HintButton;
